import {HttpErrorResponse} from '@angular/common/http';
import {RequestParamModel} from '../../models';
import {MilestoneStatusService} from './../../apiservices/milestone-status.service';
import {ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter, SimpleChanges, model, effect, OnChanges} from '@angular/core';
import {AlertService, DebugLoggerService, HelperService} from '../../services';
import {Constants} from '../../constants';
import moment from 'moment';
import {formatNoteDateTime} from '../../utils/table-date.util';

@Component({
  standalone: false,
    selector: 'app-milestones-status',
    // Eager: Angular 22 defaults every component to OnPush, which would leave this view
    // unpainted after its subscribe callbacks (see app.component.ts for the full note).
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './milestones-status.component.html',
    styleUrls: ['./milestones-status.component.css']
})
export class MilestonesStatusComponent implements OnInit, OnChanges {
    private isLoadingMilestones = false; // ✅ Prevent duplicate API calls
    // ✅ Auto-open the note popup once when the active step is Awaiting Feedback.
    // Reset only when the active step moves away from Awaiting Feedback so it re-arms on re-entry.
    private hasAutoOpenedFeedbackNote = false;
    // The auto-open must fire ONLY when the user actively switches INTO Awaiting Feedback from
    // the detail screen — never on a passive load (e.g. opening the detail from the listing
    // while the request already sits on Awaiting Feedback). We baseline the active step on the
    // first RESOLVED data load and treat an initial Awaiting Feedback as "already handled".
    private hasSeededActiveStatus = false;

    @Input() type: any
    @Input() modelOrder!: any
    @Input() modelQuoteProduct!: any
    @Input() orderId: number
    @Input() internalNoteModel: any
    @Input() awaitFeedbackNoteId: any
    @Input() isPartialScanned: any
    @Input() isSampleRequestCancel!: boolean;
    @Input() isDisplayOnDespatch!: boolean;
    @Input() quoteProductId: any
    @Input() currentStatusId: any
    @Input() isOrderCancel: any
    @Input() isOrderProduction: any;
    @Input() isAllowAddAwaitingFeedbackMilestoneNote: any;
    @Output() ChangeStatusEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() bigPostEvent: EventEmitter<any> = new EventEmitter<any>();
    @Input() refreshTrigger: boolean;
    @Output() addNoteEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() sendMailOnShippingQuoteRequiredEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() openShippingPriceEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() warehouseArrivalDateEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() updateStockRequiredDateEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() convertToQuoteEvent: EventEmitter<void> = new EventEmitter<void>();
    @Input() feedbackAffectedProducts: any;
    protected readonly Constants = Constants;
    milestoneList: any = []
    s3BucketImageURL = Constants.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/WEBSITE_ASSET_STAGING';
    manualDeliveryQuoteStatus = Constants.QUOTE_MANUAL_DELIVERY_QUOTE_REQUIRED_SHORT;
    reactivatedQuoteStatus = Constants.QUOTE_REACTIVATED_SHORT;
    isOrder = Constants.ORDER_TYPE_ORDER_SHORT;
    availableAtWarehouseStatus = Constants.ORDER_PACKING_SHORT;
    public statusChangeTrigger = model(false);
    showLeftCollapsed = false;
    isSampleMilestone = false;
    isQuoteMilestone = false;
    isOrderMilestone = false;
    constants = Constants;
    isDisplayPulsingEffect: boolean = false;
    private readonly leftCollapseShortCodes = new Set(['OR', 'IP', 'IT', 'DIT', 'DST', 'CC', 'SP']);
    demoMilestones: any = [
        {
            key: 'order-placed',
            title: 'Order<br /> Placed',
            date: '07/03/2025 09:58 PM',
            class: 'order-placed',
            next: 'in-productions',
            completed: true,
            selected: false,
            showActions: false,
            visible: true
        },
        {
            type: 'arrow',
            direction: 'right',
            icon: '/assets/admin/images/right-double-icon.svg'
        },
        {
            key: 'in-productions',
            title: 'In<br /> Productions',
            date: '',
            class: 'in-productions',
            next: 'in-transit',
            completed: true,
            selected: false,
            showActions: false,
            visible: true
        },
        {
            key: 'in-transit',
            title: 'In<br /> Transit',
            date: '',
            class: 'in-transit',
            next: 'customs-held',
            completed: true,
            selected: false,
            showActions: false,
            visible: true
        },
        {
            key: 'customs-held',
            title: 'Customs<br /> Held',
            date: '',
            class: 'customs-held',
            next: 'available-at',
            completed: true,
            selected: false,
            showActions: false,
            visible: true
        },
        {
            key: 'available-at-warehouse',
            title: 'Available At<br /> Warehouse',
            date: '11/03/2025 05:41 PM',
            class: 'available-at-warehouse',
            next: 'delivery-unconfirmed',
            completed: true,
            selected: true,
            showActions: false,
            visible: true
        },
        {
            type: 'arrow',
            direction: 'left',
            icon: '/assets/admin/images/left-double-icon.svg',
            visible: true
        },
        {
            key: 'delivery-unconfirmed',
            title: 'Delivery<br /> Unconfirmed',
            date: '11/03/2025 05:41 PM',
            class: 'delivery-unconfirmed',
            next: 'delivery-out-tender',
            completed: false,
            selected: false,
            showActions: false
        },
        {
            key: 'delivery-out-tender',
            title: 'Delivery<br /> Out To Tender',
            date: '',
            class: 'delivery-out-tender',
            next: 'delivery-confirmed',
            completed: false,
            selected: false,
            showActions: false
        },
        {
            key: 'delivery-confirmed',
            title: 'Delivery<br /> Confirmed',
            date: '',
            class: 'delivery-confirmed',
            next: 'delivery-despatched',
            completed: false,
            selected: false,
            showActions: false
        },
        {
            key: 'delivery-despatched',
            title: 'Delivery<br /> Despatched',
            date: '',
            class: 'delivery-despatched',
            next: 'delivered',
            completed: false,
            selected: false,
            showActions: false
        },
        {
            key: 'delivered',
            title: 'Delivered',
            date: 'GCFL01',
            class: 'delivered',
            next: 'awaiting',
            completed: false,
            selected: false,
            showActions: false
        },
        {
            key: 'awaiting',
            title: 'Awaiting<br /> Feedback',
            date: '',
            class: 'awaiting',
            next: 'order-completed',
            completed: false,
            selected: false,
            showActions: false,
            visible: true
        },
        {
            key: 'order-completed',
            title: 'Order<br /> Completed',
            date: '',
            class: 'order-completed',
            next: '',
            completed: false,
            selected: false,
            showActions: false,
            visible: true
        }
    ];
    currentStatusShortCode: string = '';
    isDisplayWarehouseDateIconForOrder: boolean = false;
    orderWarehouseArrivalDate: any = '';
    @Input() stockRequiredDateFromDesptch!: any;
    @Input() quoteProductStatus!: any;
    @Input() orderWarehouseArrivalDateFromDespatch!: any;
    @Input() isOrderWarehouseArrivalDateFromDespatch: boolean = false;
    

    // Stable identity for @for tracking in template
    trackByStatus(index: number, status: any): string | number {
        return status?.id ?? `${this.type}-${index}`;
    }

    constructor(
        private statusService: MilestoneStatusService,
        private alertService: AlertService,
        public helperFunction: HelperService,
        private debugLogger: DebugLoggerService,
    ) {
        effect(() => {
            if (this.statusChangeTrigger()) {
                this.getMilestoneData();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.debugLogger.log('🔄 Milestone ngOnChanges', {
            changes: Object.keys(changes),
            orderId: this.orderId,
            type: this.type,
            isLoadingMilestones: this.isLoadingMilestones
        });

        // ✅ CRITICAL FIX: Reset loading flag when orderId changes (component reused for different quote)
        if (changes['orderId']) {
            this.debugLogger.log('🔄 OrderId changed - resetting isLoadingMilestones flag');
            this.isLoadingMilestones = false;
            // Re-baseline the auto-open state for the newly loaded request so the first
            // load of the new request is treated as passive (no auto-open).
            this.hasSeededActiveStatus = false;
            this.hasAutoOpenedFeedbackNote = false;
        }

        if (changes['refreshTrigger']) {
            this.getMilestoneData();
        }

        // Update current status short code and collapse side when currentStatusId changes
        if (changes['currentStatusId']) {
            const current = this.milestoneList.find((e: any) => e.id === this.currentStatusId);
            this.currentStatusShortCode = current?.short_name || '';
            // If current status is in left group -> collapse left (showLeftCollapsed=true). Otherwise do NOT collapse left.
            this.showLeftCollapsed = this.leftCollapseShortCodes.has(this.currentStatusShortCode);
            // Auto-open the note popup when the active step lands on Awaiting Feedback
            this.maybeAutoOpenFeedbackNote();
        } else {
            this.currentStatusShortCode = this.milestoneList.find((e) => e.id === this.currentStatusId)?.short_name;
        }

        if (this.modelOrder?.is_split_production) {
            this.isDisplayWarehouseDateIconForOrder = false;
        }

        // Check if all products have the same container_id
        const firstContainerId = this.modelOrder?.quote_product?.[0]?.container_id;
        const allSameContainer = this.modelOrder?.quote_product?.every(
            (p: any) => p.container_id !== null && firstContainerId !== null && p.container_id === firstContainerId
        );
        if (allSameContainer) {
            this.isDisplayWarehouseDateIconForOrder = true;
            let containerDetail = this.modelOrder?.quote_product?.[0]?.container;
            if (containerDetail && containerDetail.anticipated_warehouse_arrival_date) {
                this.orderWarehouseArrivalDate = containerDetail.anticipated_warehouse_arrival_date;
            }
        }
    }

    ngOnInit(): void {
        this.debugLogger.log('🎯 Milestone ngOnInit', {
            type: this.type,
            orderId: this.orderId,
            isLoadingMilestones: this.isLoadingMilestones
        });

        // Reset loading flag on init in case component was recreated
        this.isLoadingMilestones = false;

        this.getMilestoneData();
        this.isSampleMilestone = this.type === Constants.ORDER_TYPE_SAMPLE_SHORT;
    }

    getStatusClass(index: number): string {
        // let status = this.milestoneList?.[index + 1]?.formatted_name;
        const formattedName: string | undefined = this.milestoneList?.[index]?.formatted_name;
        if (!formattedName) return '';
        return formattedName.toLowerCase().replace(/<br\s*\/?>/gi, '').replace(/\s+/g, '-');
    }

    getMilestoneData() {
        this.debugLogger.log('📊 getMilestoneData called', {
            type: this.type,
            orderId: this.orderId,
            isLoadingMilestones: this.isLoadingMilestones
        });

        // ✅ Don't make duplicate API calls if one is already in progress
        if (this.isLoadingMilestones) {
            this.debugLogger.log('⏭️ Skipping getMilestoneData - already loading');
            return;
        }

        this.debugLogger.log('✅ Setting isLoadingMilestones = true');
        this.isLoadingMilestones = true;

        if (this.type === Constants.ORDER_TYPE_SAMPLE_SHORT) {
            this.isSampleMilestone = true;
        } else if (this.type === Constants.ORDER_TYPE_ORDER_SHORT) {
            this.isOrderMilestone = true;
        } else {
            this.isQuoteMilestone = true;
        }
        const requestParamModel = new RequestParamModel();
        if (this.isDisplayOnDespatch) {
            requestParamModel.addDefaultFilters('display_on', Constants.ORDER_STATUS_DISPLAY_FOR_DESPATCH, 'number');
        }
        delete requestParamModel.pageSize;

        this.debugLogger.log('🚀 Starting API call getMilestoneStatus', {
            orderId: this.orderId,
            type: this.type
        });

        this.statusService.getMilestoneStatus(requestParamModel, this.orderId, this.type)
            .subscribe({
                next: (data) => {
                    this.debugLogger.log('✅ API SUCCESS - getMilestoneStatus', {
                        orderId: this.orderId,
                        type: this.type,
                        dataReceived: !!data,
                        dataLength: data?.data?.length
                    });

                    if (this.quoteProductId) {
                        this.debugLogger.log('quoteProductId', this.quoteProductId);
                        this.milestoneList = data.data.find((e) => e.quote_product_id == this.quoteProductId)?.statuses || [];
                    } else {
                        this.milestoneList = data.data;
                    }
                    if (this.type === Constants.ORDER_TYPE_ORDER_SHORT) {
                        // this.debugLogger.log('this.modelOrder', this.modelOrder);
                        if (!(this.modelOrder?.is_split_delivery && this.modelOrder?.is_split_production) && !this.modelOrder?.is_consumable_order) {
                            this.milestoneList.map((milestone: any) => {
                                if (milestone?.short_name === Constants.ORDER_RECEIVED_SHORT) {
                                    // Push the left arrow after the current milestone
                                    this.milestoneList.splice(this.milestoneList.indexOf(milestone) + 1, 0, {
                                        type: 'arrow',
                                        direction: 'left',
                                        icon: '/assets/admin/images/right-double-icon.svg'
                                    });
                                }
                                if (milestone?.short_name === Constants.ORDER_PACKING_SHORT) {
                                    // Push the right arrow after the current milestone
                                    this.milestoneList.splice(this.milestoneList.indexOf(milestone) + 1, 0, {
                                        type: 'arrow',
                                        direction: 'right',
                                        icon: '/assets/admin/images/left-double-icon.svg'
                                    });
                                }
                            });
                        }
                        // this.debugLogger.log('this.milestoneList', this.milestoneList);

                        // Determine collapse side based on current status short code after data load as well
                        const current = this.milestoneList.find((e: any) => e.id === this.currentStatusId);
                        this.currentStatusShortCode = current?.short_name || '';
                        // Reverse: If in left group -> collapse left
                        this.showLeftCollapsed = this.leftCollapseShortCodes.has(this.currentStatusShortCode);
                        if (!this.modelOrder.is_split_delivery) {
                            this.getSRDTooltipData();
                        }
                    }

                    if (this.type === Constants.QUOTE_PRODUCT_TYPE && !this.modelOrder.is_split_delivery) {
                        this.getSRDTooltipData();
                    }

                    this.debugLogger.log('✅ Milestone data processed', {
                        milestoneCount: this.milestoneList?.length,
                        type: this.type
                    });

                    // Auto-open the note popup once the step data is loaded and settled
                    this.maybeAutoOpenFeedbackNote();

                    // Wrap in try-catch to prevent errors if component is destroyed
                    try {
                        this.statusChangeTrigger.set(false);
                    } catch (e) {
                        this.debugLogger.log('⚠️ Could not set statusChangeTrigger (component destroyed)');
                    }

                    this.debugLogger.log('✅ Resetting isLoadingMilestones = false');
                    this.isLoadingMilestones = false;
                },
                error: (error: HttpErrorResponse) => {
                    this.debugLogger.log('❌ API ERROR - getMilestoneStatus', {
                        orderId: this.orderId,
                        type: this.type,
                        error: error?.message,
                        status: error?.status
                    });

                    const errorMessage = error?.message || 'Failed to fetch milestone data.';
                    this.debugLogger.log('errorMessage', errorMessage);
                    // this.alertService.error(errorMessage);

                    // Wrap in try-catch to prevent errors if component is destroyed
                    try {
                        this.statusChangeTrigger.set(false);
                    } catch (e) {
                        this.debugLogger.log('⚠️ Could not set statusChangeTrigger (component destroyed)');
                    }

                    this.debugLogger.log('✅ Resetting isLoadingMilestones = false (after error)');
                    this.isLoadingMilestones = false;
                }
            });
    }

    changeMilestoneStatus(status: any): void {
        this.ChangeStatusEvent.emit(status);
    }

    getStatusTooltip(internalNoteModel: any[], status: any): string {
        if ([Constants.SAMPLE_FOLLOW_UP_SHORT, Constants.SAMPLE_COMPLETE_SHORT].includes(status.short_name)) {
            const matchingNote = internalNoteModel.find((note) => note.status?.name === status.name);

            if (matchingNote) {
                const hasName = matchingNote.backend_user?.first_name || matchingNote.backend_user?.last_name;
                const adminName = hasName ? `${matchingNote.backend_user.first_name || ''} ${matchingNote.backend_user.last_name || ''}`.trim() : 'GatherCo System';
                const noteDate = this.getNoteDate(matchingNote);
                return `<b>${adminName}</b> ${noteDate}<br>${matchingNote.note}`;
            }

            return '';
        }
        return status.status_tooltip || '';
    }

    /**
     * Stamp inside the milestone tooltip. Shares `internal-notes.getNoteDate`'s
     * formatter so the note reads the same Australian time in the tooltip as it
     * does in the notes panel — a bare `moment()` here rendered the Node API's
     * UTC timestamp in the viewer's own browser zone.
     */
    getNoteDate(noteDetail: any, withTime: boolean = true): string {
        const date = noteDetail?.modified_at?.trim() || noteDetail?.created_at?.trim();

        return date ? formatNoteDateTime(date, withTime) : '';
    }

    showAddNoteIcon(status: any): boolean {
        return status.short_name === status.display_note_icon_for &&
            (
                status.display_note_icon_for === Constants.SAMPLE_ORDER_FOLLOW_UP_SHORT ||
                status.display_note_icon_for === Constants.SAMPLE_FOLLOW_UP_SHORT
            );
    }

    handleAddNoteClick(status: any): void {
        if (this.isSampleRequestCancel) {
            return;
        }
        this.addNoteEvent.emit(status);
    }

    /**
     * Auto-open the note popup only when the user actively switches the active sample step
     * INTO Awaiting Feedback from the detail screen. It must NOT open on a passive load
     * (e.g. opening the detail from the listing while the request is already on Awaiting
     * Feedback) — so the first data load is recorded as a baseline and never auto-opens;
     * only a subsequent transition of the active step into Awaiting Feedback opens the popup.
     *
     * Reuses the same handler as the note-icon click (handleAddNoteClick) so both entry
     * points share one code path. Fires a single time per entry into Awaiting Feedback and
     * re-arms only after the active step moves away from it.
     */
    private maybeAutoOpenFeedbackNote(): void {
        if (!this.isSampleMilestone || !this.milestoneList?.length) {
            return;
        }
        const activeStatus = this.milestoneList.find((e: any) => e.id === this.currentStatusId);
        // The Awaiting Feedback step is the active step that renders the note icon.
        // showAddNoteIcon is data-driven (short_name/display_note_icon_for) and covers both
        // 'SAF' and 'FU', so we derive the state from it rather than a hardcoded short_name.
        const isAwaitingFeedbackNoteStep = !!activeStatus && this.showAddNoteIcon(activeStatus);

        // First time we have a RESOLVED active step, record it as a baseline and do NOT
        // auto-open: a request that loads already on Awaiting Feedback is marked "already
        // handled" (hasAutoOpenedFeedbackNote = true) so it stays closed.
        //
        // Only baseline once activeStatus is resolved. This component fetches its milestone
        // list via orderId, independently of when the parent sets currentStatusId
        // (modelOrder.status_id). On initial load getMilestoneData can finish BEFORE
        // currentStatusId is set, so activeStatus is momentarily undefined; baselining on that
        // empty state would make the later "undefined -> Awaiting Feedback" assignment look
        // like a user switch INTO the step and wrongly auto-open the note popup (the reported
        // bug). Waiting for a resolved active step captures the real loaded status instead.
        if (!this.hasSeededActiveStatus) {
            if (!activeStatus) {
                return;
            }
            this.hasSeededActiveStatus = true;
            this.hasAutoOpenedFeedbackNote = isAwaitingFeedbackNoteStep || this.isCompletedStep(activeStatus);
            return;
        }

        if (!isAwaitingFeedbackNoteStep) {
            // Re-arm auto-open once the active step moves away from Awaiting Feedback, so a
            // later switch back into it opens the note popup again — except from Completed: the
            // only way from there into Awaiting Feedback is the move back, a correction whose
            // feedback note was written the first time round.
            this.hasAutoOpenedFeedbackNote = this.isCompletedStep(activeStatus);
            return;
        }
        // Open once per entry into Awaiting Feedback, and not while the request is cancelled.
        // Because the baseline marked an initial Awaiting Feedback as already handled, this
        // only fires after the active step leaves Awaiting Feedback and returns to it — i.e. a
        // real switch INTO the step from the detail screen.
        if (this.hasAutoOpenedFeedbackNote || this.isSampleRequestCancel) {
            return;
        }
        this.hasAutoOpenedFeedbackNote = true;
        // Defer so the popup opens after the step has rendered and change detection has settled.
        // This handles the live confirm-action transition (status flips from an async callback),
        // avoids opening against a not-yet-rendered anchor, and prevents
        // ExpressionChangedAfterItHasBeenCheckedError from opening during change detection.
        Promise.resolve().then(() => this.handleAddNoteClick(activeStatus));
    }

    private isCompletedStep(status: any): boolean {
        return status?.short_name === Constants.SAMPLE_ORDER_COMPLETED_SHORT;
    }

    /** A Completed sample request can step back to Awaiting Feedback — the one ticked step that stays clickable. */
    canMoveBackTo(status: any): boolean {
        return this.isSampleMilestone && !this.isSampleRequestCancel &&
            status?.short_name === Constants.SAMPLE_ORDER_FOLLOW_UP_SHORT &&
            this.currentStatusShortCode === Constants.SAMPLE_ORDER_COMPLETED_SHORT;
    }

    getAddNoteTooltip(status: any): string {
        return this.awaitFeedbackNoteId ? 'Edit Milestone Note' : 'Add Milestone Note';
    }

    showBigPostIcon(status: any): boolean {
        return !this.isPartialScanned && status.short_name === status.display_big_post_push_icon_for &&
            status.display_big_post_push_icon_for === Constants.SAMPLE_ORDER_PACKING_SHORT;
    }

    bigPost() {
        if (this.isSampleRequestCancel) {
            return;
        }
        this.bigPostEvent.emit(true);
    }

    openSendMailOnShippingQuoteRequired() {
        this.sendMailOnShippingQuoteRequiredEvent.emit(true);
    }

    openShippingPriceForm() {
        this.openShippingPriceEvent.emit(true);
    }

    onArrowClick(direction: 'left' | 'right', _arrowIndex: number): void {
        // Collapse left if clicking left; expand left if clicking right
        this.showLeftCollapsed = direction === 'left';
    }

    shouldShowMilestone(item: any, index: number): boolean {
        // If this is a consumable order, always show all milestones
        if (this.modelOrder?.is_consumable_order) {
            return true;
        }
        if (this.showLeftCollapsed) {
            const leftArrowIndex = this.milestoneList.findIndex(el => el.type === 'arrow' && el.direction === 'left');
            const rightArrowIndex = this.milestoneList.findIndex(el => el.type === 'arrow' && el.direction === 'right');
            return index > leftArrowIndex && index < rightArrowIndex;
        } else {
            const rightArrowIndex = this.milestoneList.findIndex(el => el.type === 'arrow' && el.direction === 'right');
            return index > rightArrowIndex;
        }
    }

    /**
     * Hide/Show statuses based on arrow visibility rules:
     * - When left arrow is visible (between OR and AAW), hide statuses with split_for === 'P' and short_name !== 'AAW' strictly between OR and AAW.
     * - When right arrow is visible (between AAW and AF), hide statuses with split_for === 'D' strictly between AAW and AF.
     */
    shouldShowStatus(status: any, index: number): boolean {
        const indexOR = this.milestoneList.findIndex((s: any) => s?.short_name === Constants.ORDER_RECEIVED_SHORT);
        const indexAAW = this.milestoneList.findIndex((s: any) => s?.short_name === Constants.ORDER_PACKING_SHORT);
        const indexAF = this.milestoneList.findIndex((s: any) => s?.short_name === Constants.ORDER_FOLLOW_UP_SHORT);

        // If boundaries are missing, don't hide anything
        // if (indexOR === -1 || indexAAW === -1 || indexAF === -1) return true;

        // Left arrow is visible when not collapsed and OR exists
        const leftArrowVisible = !this.showLeftCollapsed && indexOR !== -1;
        // Right arrow is visible when left side is collapsed and AAW exists
        const rightArrowVisible = this.showLeftCollapsed && indexAAW !== -1;

        if (leftArrowVisible && index > indexOR && index < indexAAW) {
            // Hide P between OR and AAW, except AAW itself
            return !(status?.split_for === 'P' && status?.short_name !== Constants.ORDER_PACKING_SHORT);
        }

        if (rightArrowVisible && index > indexAAW && index < indexAF) {
            // Hide D between AAW and AF
            return status?.split_for !== 'D';
        }

        return true;
    }

    /**
     * Show arrows only at required boundaries:
     * - Left arrow: between Order Received and Available At Warehouse (render after OR) when right side is collapsed.
     * - Right arrow: between Available At Warehouse and Awaiting Feedback (render after AAW) when left side is collapsed.
     */
    shouldShowArrow(item: any, direction?: 'left' | 'right'): boolean {
        // When called from the first (dynamic) list, we pass the current status and direction explicitly
        if (direction) {
            const isOR = item?.short_name === Constants.ORDER_RECEIVED_SHORT;
            const isAAW = item?.short_name === Constants.ORDER_PACKING_SHORT;
            if (direction === 'left') {
                return !this.showLeftCollapsed && isOR; // Show left arrow after OR
            } else if (direction === 'right') {
                return this.showLeftCollapsed && isAAW; // Show right arrow after AAW
            }
            return false;
        }

        // Backward compatibility for the demo/static milestones list, where item is the arrow itself
        if (item?.type === 'arrow') {
            if (item.direction === 'left') return !this.showLeftCollapsed;
            if (item.direction === 'right') return this.showLeftCollapsed;
        }
        return false;
    }

    getNoteTooltip(internalNoteModel: any[], orderStatus: any): string {
        let statusTooltip = '';
        const matchingNote = internalNoteModel?.find(
            (internalNote) =>
                internalNote.status?.name === orderStatus.name
        );
        if (matchingNote) {
            let adminName;
            if (!matchingNote.backend_user || !matchingNote.backend_user.first_name) {
                adminName = 'GatherCo System';
            } else {
                adminName = `${matchingNote.backend_user.first_name} ${matchingNote.backend_user.last_name}`;
            }
            const noteDate = this.getNoteDate(matchingNote, false);
            statusTooltip = `<b>${adminName}</b> ${noteDate}<br>${matchingNote.note}`;
        }
        return statusTooltip;
    }

    /**
     * Check if there's actual content to display in the tooltip
     */
    getTooltipContent(status: any): string {
        if (this.isSampleMilestone || this.isQuoteMilestone) {
            return status?.status_tooltip?.trim() || '';
        } else {
            // For order milestones, check both note tooltip and status tooltip
            const noteTooltip = this.getNoteTooltip(this.internalNoteModel, status);
            const statusTooltip = status?.status_tooltip?.trim() || '';
            return noteTooltip || statusTooltip;
        }
    }

    addWarehouseArrivalDateOpen() {
        this.warehouseArrivalDateEvent.emit(true);
    }

    openAddNoteForm(
        type: string,
        noteId: any = null,
        quoteOrderStatusId = null,
        notAllowAddMilestoneNote = false,
        changeOrderStatusTo = null,
        isDelete: boolean = false
    ) {
        this.addNoteEvent.emit({type, noteId, quoteOrderStatusId, notAllowAddMilestoneNote, changeOrderStatusTo});
    }

    /**
     * Show tooltip programmatically when hovering over the li element
     */
    showTooltip(tooltipRef: any) {
        if (tooltipRef) {
            tooltipRef.open();
        }
    }

    /**
     * Hide tooltip programmatically when leaving the li element
     */
    hideTooltip(tooltipRef: any) {
        if (tooltipRef) {
            tooltipRef.close();
        }
    }

    trackByReactivatedDateFunction(index: number, item: any): any {
        return item.id; // Replace 'id' with the unique identifier of your items
    }

    formatDate(date: string) {
        return date != null ? moment(date).format('DD/MM/YYYY') : 'N/A';
    }

    getSRDTooltipData(): { text: string } {
        let tooltipText = {text: 'No Stock Required Date (SRD) Added'};
        if (this.modelOrder?.stock_required_date == null || this.modelOrder?.stock_required_date == '') {
            return tooltipText;
        }

        if (this.modelOrder?.stock_required_date !== '') {
            this.isDisplayPulsingEffect = false;
            tooltipText = {
                text: 'Stock Required Date (SRD): ' + this.formatDate(this.modelOrder?.stock_required_date)
            };
        }
        const isDespatchedStatusExist = this.Constants.GOODS_DISPATCHED_MILESTONE_STATUS_ARRAY.find(
            (item) => item == this.modelOrder?.status?.short_name
        );
        if (isDespatchedStatusExist) {
            this.isDisplayPulsingEffect = false;
            return tooltipText;
        }

        if (moment(this.modelOrder?.stock_required_date).isSameOrBefore(moment(), 'day')) {
            this.isDisplayPulsingEffect = true;
            tooltipText = {text: 'SRD Expired: ' + this.formatDate(this.modelOrder?.stock_required_date)};
        }

        if (this.orderWarehouseArrivalDate != '' && moment(this.orderWarehouseArrivalDate).isAfter(moment(this.modelOrder?.stock_required_date), 'day')) {
            this.isDisplayPulsingEffect = true;
            tooltipText = {text: 'SRD Conflict: ' + this.formatDate(this.modelOrder?.stock_required_date)};
        }


        return tooltipText;
    }

    getSRDTooltipDataForQuoteProduct(stock_required_date, warehouse_arriva_date ): { text: string, isDisplayPulsingEffect: boolean } {
        let tooltipText = {text: 'No Stock Required Date (SRD) Added', isDisplayPulsingEffect: false};
        if (stock_required_date == null || stock_required_date == '') {
            return tooltipText;
        }
        
        stock_required_date = new Date(stock_required_date);

        if (stock_required_date !== '') {
            tooltipText = {
                text: 'Stock Required Date (SRD): ' + this.formatDate(stock_required_date),
                isDisplayPulsingEffect: false
            };
        }
        const isDespatchedStatusExist = this.Constants.GOODS_DISPATCHED_MILESTONE_STATUS_ARRAY.find(
            (item) => item == this.quoteProductStatus?.short_name
        );
        if (isDespatchedStatusExist) {
            return tooltipText;
        }

        if (moment(stock_required_date).isSameOrBefore(moment(), 'day')) {
            tooltipText = {text: 'SRD Expired: ' + this.formatDate(stock_required_date), isDisplayPulsingEffect: true};
        }

        if(this.isOrderWarehouseArrivalDateFromDespatch){
            if (warehouse_arriva_date != '' && moment(warehouse_arriva_date).isAfter(moment(stock_required_date), 'day')) {
                tooltipText = {text: 'SRD Conflict: ' + this.formatDate(stock_required_date), isDisplayPulsingEffect: true};
            }
        }else {
            if (this.orderWarehouseArrivalDate != '' && moment(this.orderWarehouseArrivalDate).isAfter(moment(stock_required_date), 'day')) {
                tooltipText = {text: 'SRD Conflict: ' + this.formatDate(stock_required_date), isDisplayPulsingEffect: true};
            }
        }

        return tooltipText;
    }

    protected readonly model = model;

    isSample(): boolean {
        return this.type == Constants.ORDER_TYPE_SAMPLE_SHORT ? true : false;
    }

    /** The alternative GatherCo products the PRODUCTS reason recorded — full product rows,
     *  listed under "Affected Product" in its row design. One row per product. */
    get alternativeProducts(): any[] {
        const seen = new Set<string>();
        return (this.feedbackAffectedProducts?.questions ?? [])
            .flatMap((question: any) => question?.alternative_products ?? [])
            .filter((p: any) => {
                const key = String(p?.id ?? '');
                if (!key || seen.has(key)) {
                    return false;
                }
                seen.add(key);
                return true;
            });
    }

    productImage(item: any) {
        if (!this.isSample() && item?.is_custom_product) {
            return `${Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL}/WEBSITE_ASSET_STAGING/no-image-product.svg${Constants.IMAGE_SIZE_50_X_50}`;
        } else if (this.isSample()) {
            const images = item?.sample_product?.sample_product_image || [];
            const match = images.find((img: any) => img.type === "FHI" && img.status === "A");

            if (match?.path) {
                return `${Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL}/${match.path}${Constants.IMAGE_SIZE_50_X_50}`;
            }
        } else {
            const images = item?.product_image || item?.product_images || [];
            let match = images.find((img: any) => img.type === "FHI" && img.status === "A");

            if (
                (item?.type == Constants.SURFACE_SORT_NAME ||
                    item?.type ==
                    Constants.PRODUCT_TYPE_SURFACE_ACCESSORY) &&
                item?.product_image
            ) {
                return `${Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL}/${match.path}${Constants.IMAGE_SIZE_50_X_50}`;

            } else if (
                (item?.type == Constants.DECOR_SORT_NAME ||
                    item?.type == Constants.PRODUCT_TYPE_DECOR_ACCESSORY) &&
                item?.product_image
            ) {
                return match?.path
                    ? Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                    '/' +
                    match.path +
                    Constants.IMAGE_SIZE_50_X_50
                    : '';
            } else if (item?.consumables_prices) {
                if (item?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_LATICRETE_ADHESIVE) {
                    return Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                        '/ASSETS/PRODUCT/CONSUMABLE_PRODUCT/adhesive.png' +
                        Constants.IMAGE_SIZE_50_X_50;
                }
                if (item?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_DEFENDER || item?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_GOLD) {

                    return Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                        '/ASSETS/PRODUCT/CONSUMABLE_PRODUCT/sealer.png' +
                        Constants.IMAGE_SIZE_50_X_50;
                }
            }
        }
    }
}
